<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                    SEPA-Mandatslisten bearbeiten
                <template v-slot:buttons>
                    <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
                        <inertia-link :href="route('sepa.transfers', {sepa: sepa})" class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Überweiser
                        </inertia-link>
                        <button type="button" class="ml-3 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            <label for="rsa_upload">
                                IBANs entschlüsseln
                            </label>
                        </button>
                        <input id="rsa_upload" type="file" class="hidden" @change="decrypt" />
                        <button type="button" class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            <label for="rsa_upload_download">
                                Sepa-XML herunterladen
                            </label>
                        </button>
                        <input id="rsa_upload_download" type="file" class="hidden" @change="decrypt_download" />
                    </div>
                </template>
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="mb-4">
                    <label for="search" class="block text-sm font-medium text-gray-700">Suche</label>
                    <div class="mt-1">
                        <input type="text" name="search" id="search" v-model="search" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Suchen...">
                    </div>
                </div>
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Name
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                IBAN
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Kundennummer
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Mandatsreferenz
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Datum
                                            </th>
                                            <th scope="col" class="relative px-6 py-3 flex justify-end">
                                                <span class="sr-only">Bearbeiten</span>
                                                <inertia-link :href="route('sepa.confirm', {sepa: sepa})" type="button" class="inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    <PlusIcon class="h-5 w-5" aria-hidden="true" />
                                                </inertia-link>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(mandate, mandateIdx) in mandates_decrypted.filter(item => { for(x of ['name', 'kdnr', 'reference']) {if(item[x].toLowerCase().includes(search.toLowerCase())) return true} return false})" :key="mandate.id" :class="mandateIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {{ mandate.name }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ mandate.iban_decrypted  ?? mandate.iban_censored }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ mandate.kdnr }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ mandate.reference }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ mandate.date }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <a @click="$inertia.delete(route('sepa.delete', {mandate: mandate}))" class="text-indigo-600 hover:text-indigo-900 ml-4 cursor-pointer">Löschen</a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetApplicationLogo from "@/Jetstream/ApplicationLogo";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetInput from "@/Jetstream/Input";
import JetLabel from "@/Jetstream/Label";
import JetInputError from "@/Jetstream/InputError";
import Editor from "@/Pages/Email/Editor";
import {PlusIcon, ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/solid'
import { JSEncrypt } from 'jsencrypt'
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";
import FarmTitle from "@/Layouts/FarmTitle";
import axios from 'axios';

export default {
    name: "ListEdit",
    components: {
        FarmTitle,
        Label,
        Button,
        Editor,
        JetApplicationLogo,
        JetDialogModal,
        JetInput,
        JetInputError,
        JetLabel,
        AppLayout,
        PlusIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    props: ['sepa', 'mandates', 'farm'],
    data() {
        return {
            private_key: null,
            mandates_decrypted: this.mandates,
            search: ''
        }
    },
    methods: {
        async decrypt(event) {
            var data = new FormData()
            data.append('rsa_key', event.target.files[0] || '')
            data.append('sepa', this.sepa || '')

            await axios.post(route('sepa.decrypt', { sepa: this.sepa }), data)
                .then(x => {
                    if(x.status == 200)
                        return this.mandates_decrypted = x.data
                    return alert("Falscher Key")
                })
            event.target.value="";
        },
        async decrypt_download(event) {
            var data = new FormData()
            data.append('rsa_key', event.target.files[0] || '')
            data.append('sepa', this.sepa || '')

            await axios.post(route('sepa.download.link', { sepa: this.sepa }), data)
                .then(x => {
                    if(x.status == 200)
                        return window.open(x.data)
                    return alert("Falscher Key")
                })
            event.target.value="";
        },
    }
}
</script>
